import { getMaskedCanvas } from './getMaskedCanvas';

export function supportsSvgMaskedCanvas() {
  try {
    const designImage = new Image(1, 1);
    const maskImage = new Image(1, 1);
    maskImage.src =
      'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciLz4=';
    getMaskedCanvas(designImage, maskImage, { x: 1, y: 1 }, { x: 1, y: 1 }, null);
  } catch (e) {
    return false;
  }

  return true;
}
